import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

interface ElementData {
  idTrade?: string;
  reExecuteDate?: string;
  request?: string;
  responseError?: string;
  reExecutionNotImplementedDate?: string;
  message?: string;
  requestUrl?: string;
}

@Component({
  selector: 'app-json-modal',
  templateUrl: './json-modal.component.html',
  styleUrls: ['./json-modal.component.sass'],
})
export class JsonModalComponent {
  element: ElementData;
  formattedMessage: string = '';
  formattedResponseError: string = '';
  formattedRequest: string = '';
  keyValuePairs: { key: string; value: string }[] = [];

  constructor(
    public dialogRef: MatDialogRef<JsonModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { element: ElementData }
  ) {
    this.element = data.element;
    this.processElement();
  }

  private processElement(): void {
    const excludedKeys = ['message', 'request', 'responseError'];

    this.formattedMessage = this.formatJsonField(this.element.message);
    this.formattedRequest = this.formatJsonField(this.element.request);
    this.formattedResponseError = this.formatJsonField(this.element.responseError);

    // Monta dinamicamente os pares chave/valor
    this.keyValuePairs = Object.entries(this.element)
      .filter(([key]) => !excludedKeys.includes(key)) // remove os que já são exibidos embaixo
      .map(([key, value]) => ({
        key,
        value: value ?? 'N/A',
      }));
  }

  private formatJsonField(field?: string): string {
    if (!field) {
      return 'N/A';
    }
    try {
      const parsed = JSON.parse(field);
      return JSON.stringify(parsed, null, 2);
    } catch (error) {
      return field;
    }
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
